import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'app-temp-access-login',

  templateUrl: './temp-access-login.component.html',

  styleUrls: ['./temp-access-login.component.css']

})

export class TempAccessLoginComponent implements OnInit {

  captcha: number | String = 'XXXX';

  version: string = `${(<any>window).version}`

  webAppName = (<any>window).webAppName;

  appName = (<any>window).appName;

  mdlLogin = new FormGroup({

    strMobile: new FormControl(''),

    strPassword: new FormControl(''),

    strCaptcha: new FormControl(''),

    iTemporaryAccess: new FormControl(''),

  });

  constructor(

    private el: ElementRef,

    private router: Router,

    private notifyService: NotificationService,

    private otherService: OtherService,

    private route: ActivatedRoute,

        private gurdService: GurdServiceService,
    

  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {

      this.mdlLogin.controls['iTemporaryAccess'].setValue(params['ita']);

      this.get_Captcha();

    })

  }

  get_Captcha() {

    this.captcha = this.generateRandomNumber(1111, 9999);

  }

  generateRandomNumber(min: any, max: any) {

    return Math.floor((Math.random() * (max - min + 1) + min));

  }

  login = async () => {

    var model = this.mdlLogin.value;

    if (!model.strMobile) return this.notifyService.showError('نام کاربری نمی تواند خالی باشد');

    if (model.strMobile.length < 10) return this.notifyService.showError('شماره موبایل را به درستی وارد کنید');

    if (!model.strPassword) return this.notifyService.showError('رمز عبور نمی تواند خالی باشد');

    if (!model.strCaptcha || model.strCaptcha != this.captcha) {

      this.captcha = this.generateRandomNumber(1111, 9999)

      return this.notifyService.showError('کد امنیتی صحیح نمی باشد');

    }

    try {

      this.otherService.Showspinner();

      const resp = await axios.post('TemporaryAccess_Login', this.otherService.stringNumberToNumber(model));

      let res = JSON.parse(resp.data);

      if (res.iResult == 0) return this.notifyService.showError(res.strError)

      localStorage.setItem('Session', this.gurdService.encrypt(res.strSession));

      localStorage.setItem('ID', this.gurdService.encrypt(res.iSystemUser.toString()));

      this.router.navigate(['tempTracker', res.strUnitID], { queryParams: { ita: res.iTemporaryAccess } })

    }

    catch (err) {

      this.notifyService.showError("متاسفانه خطایی رخ داده است!");

    }


    finally {

      this.otherService.nonespinner();

    }

  }

}
